import { ReactNode, useEffect, useMemo, useReducer } from 'react'

import {
  SettingsContext,
  settingsReducer,
  SettingsState,
} from 'Features/Projects/Scenarios/EditSettings/EditSettings.types'
import { useParams } from 'react-router-dom'
import { useProjectData } from 'Features/Projects/Scenarios/Scenarios.data'
import { Scenario } from 'Features/Projects/Scenarios/Scenarios.types'

export const SettingsProvider = ({ children }: { children: ReactNode }) => {
  const { projectId, scenarioId } = useParams<{
    projectId: string
    scenarioId: string
  }>()

  const { data: projectData } = useProjectData(projectId)

  const INITIAL_STATE: SettingsState = {
    projectId: projectId ?? '',
    scenarioId: scenarioId ?? '',
    selectedWorkCentre: 'All',
    selectedBaseSourceSite: 'All',
    scenarios: projectData?.scenariosList ?? [],
    selectedScenario: '',
  }

  const [state, dispatch] = useReducer(settingsReducer, INITIAL_STATE)

  useEffect(() => {
    if (projectData) {
      dispatch({
        type: 'PROJECT_DETAILS_FETCH',
        payload: projectData.scenariosList,
      })
      const selectedScenario = projectData.scenariosList.find(
        (scenario: Scenario) => scenario.scenarioId === scenarioId
      )?.scenarioName

      if (selectedScenario) {
        dispatch({
          type: 'UPDATE_SELECTED_SCENARIO',
          payload: selectedScenario,
        })
      }
    }
  }, [projectData, scenarioId])

  useEffect(() => {
    if (projectId) {
      dispatch({ type: 'UPDATE_PROJECT_ID', payload: projectId })
    }
    if (scenarioId) {
      dispatch({ type: 'UPDATE_SCENARIO_ID', payload: scenarioId })
    }
  }, [projectId, scenarioId])

  const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch])

  return (
    <SettingsContext.Provider value={contextValue}>
      {children}
    </SettingsContext.Provider>
  )
}
